import { render, staticRenderFns } from "./SpecialPriceAdjPrintDetail_Total.vue?vue&type=template&id=5253a83a&"
import script from "./SpecialPriceAdjPrintDetail_Total.vue?vue&type=script&lang=js&"
export * from "./SpecialPriceAdjPrintDetail_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports